import { getValidationLogic } from './getValidationLogic'

const auth = () => {
  return {
    email: {
      presence: {
        allowEmpty: getValidationLogic('auth', 'auth', 'email', 'allowEmpty'),
        message: '^inputError.blankEmail'
      },
      format: {
        pattern: getValidationLogic('auth', 'auth', 'email', 'pattern'),
        message: '^inputError.invalidEmail'
      }
    },
    password: {
      presence: {
        allowEmpty: getValidationLogic('auth', 'auth', 'password', 'allowEmpty'),
        message: '^inputError.blankPassword'
      },
      format: {
        pattern: getValidationLogic('auth', 'auth', 'password', 'pattern'),
        message: '^inputError.invalidPassword'
      }
    },
    retypePassword: {
      presence: {
        allowEmpty: false,
        message: '^inputError.blankConfirmPassword'
      },
      equality: {
        attribute: 'password',
        message: '^inputError.notMatchConfirmPassword'
      }
    },
    mobile: {
      presence: {
        allowEmpty: getValidationLogic('auth', 'auth', 'mobile', 'allowEmpty'),
        message: '^inputError.blankPhoneNumber'
      },
      format: {
        pattern: getValidationLogic('auth', 'auth', 'mobile', 'pattern'),
        message: '^inputError.invalidPhoneNumber'
      }
    },
    otp: {
      presence: {
        allowEmpty: getValidationLogic('auth', 'auth', 'otp', 'allowEmpty'),
        message: '^inputError.blankOtp'
      },
      length: {
        is: Number(getValidationLogic('auth', 'auth', 'otp', 'len')),
        message: '^inputError.invalidOtp'
      }
    }
  }
}

export default auth
